import { list_url } from "@project/sharedcomponents/apiURL"
import { getCatchErrorMessage, isblank } from "@project/sharedcomponents/utilityFunctions"
import axios from "axios"
import { getAccountSitesetting, getheaders, handleResponse, postErrorOnException } from "../Lib/commonfunctions"
import { IPOSTOCKPARTY_SERVICE_FAIL, IPOSTOCKPARTY_SERVICE_START, IPOSTOCKPARTY_SERVICE_SUCCESS, LAST_PAGE_UPDATE, LOADING_STATE, SNACKBAR_STATE } from "./types"

export const fetch_IPOStockParty_data = ({ companycode, rowsPerPage, page, order, orderBy, search_text, functions }) => {
  if (isblank(rowsPerPage)) {
    rowsPerPage = getAccountSitesetting("pagination_size")
  }
  return (dispatch) => {
    dispatch({ type: IPOSTOCKPARTY_SERVICE_START })
    dispatch({ type: LOADING_STATE, state: true })

    let data = new FormData()
    data.append("offset", page * rowsPerPage)
    data.append("type", "ipostockparty")
    data.append("limit", "All")
    data.append("sort_order", order)
    data.append("sort_by", orderBy)
    data.append("search_text", search_text)
    axios.defaults.headers.common = getheaders()
    axios({
      method: "post",
      url: list_url({ type: "ipostockparty" }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },

      data: data,
    })
      .then((response) => handleResponse(response, dispatch))
      .then((response) => {
        if (response.data.meta.code === 401) {
          ipoStockPartyServiceFail({ dispatch, response: response.data.meta.message, rowsPerPage, page, order, orderBy, search_text })
          dispatch({ type: LOADING_STATE, state: false })
        } else {
          ipoStockPartyServiceSuccess({ dispatch, user: response, rowsPerPage, page, order, orderBy, search_text })
          dispatch({
            type: LAST_PAGE_UPDATE,
            lasttype: "ipostockparty",
            lastaction: "list",
            lasttime: new Date().getTime(),
            lastdata: "",
          })
          dispatch({ type: LOADING_STATE, state: false })
        }
      })
      .catch((error) => {
        postErrorOnException(error)
        ipoStockPartyServiceFail({ dispatch, response: getCatchErrorMessage(error), rowsPerPage, page, order, orderBy, search_text })
        dispatch({ type: LOADING_STATE, state: false })
      })
  }
}

const ipoStockPartyServiceSuccess = ({ dispatch, user, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: IPOSTOCKPARTY_SERVICE_SUCCESS,
    payload: user,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}

const ipoStockPartyServiceFail = ({ dispatch, response, rowsPerPage, page, order, orderBy, search_text }) => {
  dispatch({
    type: SNACKBAR_STATE,
    payload: true,
    message: response,
    snackbarType: "error",
  })

  dispatch({
    type: IPOSTOCKPARTY_SERVICE_FAIL,
    payload: response,
    rowsPerPage: rowsPerPage,
    page: page,
    order: order,
    orderBy: orderBy,
    search_text: search_text,
  })
}
